var app = app || {};
var commentAddModal;

function relativeAddress(address)
{
    return relativePath + address;
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$( document ).ready(function() {
    app.namespace = function(ns_string) {
        var i, ns_array = ns_string.split("."), parent = app;
        for ("app" === ns_array[0] && (ns_array = ns_array.slice(1)), i = 0; i < ns_array.length; i += 1) "undefined" == typeof parent[ns_array[i]] && (parent[ns_array[i]] = {}),
        parent = parent[ns_array[i]];
        return parent;
    }, app.namespace("automation"), app.automation = function($) {
        function init() {
            $( "#adminsearchbutton, #commentmoderationbutton, #moderationbutton" ).on("click", function(event) {
                window.location.href = $(this).attr("href");
                event.preventDefault();
                return false;
            });

            /**
             * A small hack to ensure that if a moderator is selected that
             * DSA Knowledge Item permission is also ticked.
             */
            $('#moderator').change(function() {
                if(this.checked) {
                    $('#ki').prop('checked', true);
                }
            });

            $( ".follow-button" ).on("click", function(event) {
                            event.preventDefault();
                            followButton = $(this);
                            $.ajax({
                                url: $(this).attr("href"),
                                type: "POST",
                                dataType: "html",
                                data: $(this).attr("data-ajax"),
                                success: function (response) {
                                    followButton.text($(response).text());
                                    followButton.attr("href", $(response).attr("href"));
                                },
                                error: function (response) {
                                }
                            });
                return false;
            });

            var $moderationHierarchy = $('#moderation_hierarchy'),
                $moderationListWrapper = $('#moderation_list_wrapper');

            // Hide hierarchy by default or show if parentId has been selected
            if (sessionStorage.getItem('moderation-list.hierarchy-state') === 'hidden') {
                $moderationHierarchy.hide();
                $moderationListWrapper.removeClass('col-md-9').addClass('col-md-12');
            }

            $('#moderation_hierarchy_toggle').on('click', function(event) {
                event.preventDefault();

                if ($moderationHierarchy.is(':visible')) {
                    $moderationHierarchy.hide();
                    $moderationListWrapper.removeClass('col-md-9').addClass('col-md-12');
                    sessionStorage.setItem('moderation-list.hierarchy-state', 'hidden');
                } else {
                    $moderationHierarchy.show();
                    $moderationListWrapper.removeClass('col-md-12').addClass('col-md-9');
                    sessionStorage.setItem('moderation-list.hierarchy-state', 'visible');
                }
            });

            var selectedTechHubs = $moderationHierarchy.find('a.selected');
            if (selectedTechHubs) {
                $.each(selectedTechHubs, function(e) {
                    var parents = $(this).parentsUntil('ol.tree', 'li');
                    $.each(parents, function(e) {
                        $(this).children('input').attr('checked', 'checked');
                    });

                });
            }

            var moderationListUsernameFilter = $('#moderation-list-username-filter');
            moderationListUsernameFilter.on('change focus paste keyup', 'input', function(e) {
                if ($(this).val() !== '') {
                    $(this).parent().find('.glyphicon').addClass('glyphicon-remove').removeClass('glyphicon-search');
                } else {
                    $(this).parent().find('.glyphicon').addClass('glyphicon-search').removeClass('glyphicon-remove');
                }
            });

            moderationListUsernameFilter.on('blur', 'input', function(e) {
                if ($(this).val() === '') {
                    $(this).parent().find('.glyphicon').addClass('glyphicon-search').removeClass('glyphicon-remove');
                }
            });

            moderationListUsernameFilter.on('click', 'span', function(e) {
                $(this).parent().find('input[name=username]').val('').focus();
                e.preventDefault();
            });

            // Hide university details if job role not student or educator.
            var container = $('.container-main');
            var jobRole = $('#jobrole');
            var uniForm = $('#universitydetailsform');
            var companyForm = $('#companydetailsform');

            var hideForm = function(form) {
                form.hide();
            };

            var showForm = function(form) {
                form.show();
            };

            if (jobRole.val() !== '11' && jobRole.val() !== '15') {
                hideForm(uniForm);
                showForm(companyForm);
            } else {
                showForm(uniForm);
                hideForm(companyForm);
            }

            container.on('change', '#jobrole', function(e) {
                if ($(this).val() !== '11' && $(this).val() !== '15') {
                    hideForm(uniForm);
                    showForm(companyForm);
                } else {
                    showForm(uniForm);
                    hideForm(companyForm);
                }
            });
        }
        return {
            init: init
        };

}(jQuery), app.automation.init();
});



// WEBPACK FOOTER //
// ./src/js/legacy/js/automation.js